$(".question").on("click", function () {
  if ($(this).hasClass("open-q")) {
    $(this).removeClass("open-q");
    $(this).parent().removeClass("question-opened");
    $(this).siblings(".answer").slideUp();
    $(this).children(".arrow-down").removeClass("flip");
  } else {
    $(this).addClass("open-q");
    $(this).parent().addClass("question-opened");
    $(this).siblings(".answer").slideDown();
    $(this).children(".arrow-down").addClass("flip");
  }
});

var isMobile = window.matchMedia("only screen and (max-width: 768px)");

if (isMobile.matches) {
  $(".faq-title-wrap").on("click", function () {
    if ($(this).hasClass("open-outer-q")) {
      $(this).removeClass("open-outer-q");
      $(this).siblings(".faq-questions-wrap").slideUp();
      $(this).children(".arrow-down").removeClass("flip");
    } else {
      $(this).addClass("open-outer-q");
      $(this).siblings(".faq-questions-wrap").slideDown();
      $(this).children(".arrow-down").addClass("flip");
    }
  });
  if (window.location.hash) {
    var hash = window.location.hash;
    $("a" + hash)
      .closest(".faq-wrapper")
      .children(".faq-title-wrap")
      .click();
    $("a" + hash)
      .closest(".question")
      .click();
  }
} else {
  if (window.location.hash) {
    var hash = window.location.hash;
    $("a" + hash)
      .closest(".question")
      .click();
  }
}
